import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';

import { FulfillmentPlanService } from '../../../services/fulfillment-plan-service';
import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import Global from '../../../store/global-selectors';
import { selectOrderDetailsIsCreatingReturn } from '../../../store/orders/order-details/orders.details.selectors';
import { selectOrdersDrawerReturnsFulfillmentPlanId } from '../../../store/orders/drawer/orders.drawer.selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import { getActualSalesOrderIds } from '../../../store/orders/orders.helpers';
import { FulfillmentPlannerContextDrivenOtherShippingOptions } from '../../../fulfillment-planner/other-shipping-options';

const mapStateToProps = (state) => {
  const selectedIds = Global.selectSelectedOrdersIds(state);
  const selectedSalesOrderIds = getActualSalesOrderIds(state, selectedIds) || emptyArray;
  const salesOrders =
    Global.selectEntitiesSalesOrdersByIds(state, {
      salesOrderIds: selectedSalesOrderIds,
    }) || emptyArray;
  const order = salesOrders[0];
  const salesOrderId = get(order, 'salesOrder.salesOrderId');
  const isCreatingReturn = selectOrderDetailsIsCreatingReturn(state);
  const fulfillmentPlanId = isCreatingReturn ? selectOrdersDrawerReturnsFulfillmentPlanId(state, { salesOrderId }) : selectedIds[0];
  const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }) || {};
  const shouldShowShipmentWidget = FulfillmentPlanService.shouldShowShipmentWidget(fulfillmentPlan);
  const isExternalFulfillment = Global.selectEntitiesFulfillmentPlanIsExternal(state, { fulfillmentPlanId });
  const { orderGridStatus } = fulfillmentPlan;
  const isReadOnly = orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;
  const shouldShowShippingOptions = shouldShowShipmentWidget || isReadOnly;
  return {
    isExternalFulfillment,
    fulfillmentPlanId,
    shouldShowShippingOptions,
    isReadOnly,
  };
};

const OtherShippingOptionsContainerDisplay = (props) => {
  if (!props.shouldShowShippingOptions || props.isExternalFulfillment) {
    return null;
  }

  return <FulfillmentPlannerContextDrivenOtherShippingOptions {...props} />;
};

OtherShippingOptionsContainerDisplay.propTypes = {
  shouldShowShippingOptions: PropTypes.bool,
  isExternalFulfillment: PropTypes.bool,
};

export const OtherShippingOptionsContainer = connect(mapStateToProps);
export const OtherShippingOptions = OtherShippingOptionsContainer(OtherShippingOptionsContainerDisplay);
